import { render, staticRenderFns } from "./choseCargoHoldsNumbs.vue?vue&type=template&id=da4b30e2&scoped=true&"
import script from "./choseCargoHoldsNumbs.vue?vue&type=script&lang=js&"
export * from "./choseCargoHoldsNumbs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da4b30e2",
  null
  
)

export default component.exports